import React from 'react';
import { ChevronLeft, ChevronRight, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';

const NavigationButtons = ({ 
  step, 
  totalSteps = 4,
  onPrev, 
  onNext, 
  calculating = false,
  onCancel,
  showNextOnStep3 = true
}) => {
  // Hide Next button on Step 3 if calculation is done (user should use "Proceed to Preview")
  const showNextButton = step < 3 || (step === 3 && showNextOnStep3);
  
  return (
    <div className="flex flex-col sm:flex-row justify-between gap-3 pt-6">
      <Button
        variant="outline"
        onClick={step === 1 ? onCancel : onPrev}
        data-testid="previous-button"
        className="w-full sm:w-auto"
      >
        <ChevronLeft className="w-4 h-4 mr-2" />
        {step === 1 ? 'Back' : 'Previous'}
      </Button>
      {showNextButton && (
        <Button 
          onClick={onNext} 
          data-testid="next-button" 
          className="w-full sm:w-auto bg-navy hover:bg-navy/90"
          disabled={calculating}
        >
          {calculating && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
          Next
          <ChevronRight className="w-4 h-4 ml-2" />
        </Button>
      )}
    </div>
  );
};

export default NavigationButtons;
